import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../global/global.service';

@Injectable()

export class AllService {
  constructor(private http: HttpClient,
    private globalService: GlobalService
    ) { }

  token = localStorage.getItem('key');
  urlContaE = this.globalService.urlContaE();
  //urlMiPortal = this.globalService.urlMiPortal();
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  // Servicios Portal-e (Portal proveedores PP)

  public tokenTrans(UserToken): Observable<any> {
    const obj = {
      UserToken: UserToken
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/User/Token_Transfer', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Documents

  public invoiceListStatus(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Status_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceListActions(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Actions_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public DocTypeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Document_Type_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoicePagination(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Pagination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceChangeVis(Status, IdFacturaList): Observable<any> {
    const obj = {
      Status: Status,
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Change_Visibility', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceDownloadZip(IdFacturaList) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IdFacturaList: IdFacturaList
    };
    // tslint:disable-next-line:max-line-length
    return this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip?UserToken=' + localStorage.getItem('key') + '&IdFacturaList=' + IdFacturaList;
    // const headersa = new HttpHeaders().set('Content-Type', 'application/octet-stream');
    // headersa.append('responseType', 'arrayBuffer');
    // const json = JSON.stringify(obj);
    // return this.http.get(
    // tslint:disable-next-line:max-line-length
    // this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip?UserToken=' + localStorage.getItem('key') + '&IdFacturaList=' + IdFacturaList, {headers: this.headers})
    // .catch(error => {
    //   return Observable.throw('An error occurred:', error);
    // });
  }

  // public invoiceDownloadZip(IdFacturaList): Observable<any> {
  //   // const obj = {
  //   //   UserToken: localStorage.getItem('key'),
  //   //   IdFacturaList: IdFacturaList
  //   // };
  //   // const json = JSON.stringify(obj);
  //   return this.http.get(
  //     this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip2?UserToken='+localStorage.getItem('key')+'&IdFacturaList=1,2')
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error);
  //     });
  // }

  public invoiceDelete(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceChangeStatusFromReonciledToPeding(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Change_Status_From_Reconciled_To_Pending', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceValidate(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_ReValidate', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceValidateEfos(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_ReValidate_Efos', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceReconcilliedWeb(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Reconciled_Web_Level', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceUnReconciledWeb(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_UnReconciled_Web_Level', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoicePreconciledList(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Preconciled_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceDetailList(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Detail_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoicePriorityChange(IdDocument): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IdDocument: IdDocument
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Document_Priority_Change', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public companyList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Company_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public statusReconciledList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Status_Reconciled_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceById(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }


  public invoiceDocStsSecond(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Document_Second_Type_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentPreconciledList(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Preconciled_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentDetailList(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Detail_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentPriorityChange(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Document_Priority_Change', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersByRFC(Rfc): Observable<any> {
    const obj = {
      Rfc: Rfc,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_By_Rfc_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersInvoiceById(Id_Invoice): Observable<any> {
    const obj = {
      Id_Invoice: Id_Invoice,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Invoice_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersDocEdit(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Document_New_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersInvoiceEdit(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Invoice_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }



  // Repositories

  public getRepositories(SearchKey, Page): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      SearchKey: SearchKey,
      Page: Page
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public newEditRepository(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_NewEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getRepositoryById(Id_Repository): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Repository: Id_Repository
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_ById', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getListType(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Email_Server_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public updateRepositoryStatus(Id_Repository_Email, IsActive): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IsActive: IsActive,
      Id_Repository_Email: Id_Repository_Email
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Update_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public repositoryValidated(Id_Repository_Email): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Repository: Id_Repository_Email
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Validation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public invoiceLogList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public invoiceLogPagination(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_Pagination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public rulesComboList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Rules_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public statusLogComboList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Status_Log_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public repositoryTypeComboList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Repository_Type_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public invoiceLogByRequestToken(TransacToken): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      TransacToken: TransacToken,
      Token: localStorage.getItem('jwt')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_By_Request_Token', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notificationTypeByRfcList(Rfc): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Rfc: Rfc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Notification_Type_By_Rfc_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notificationTypeNewEdit(Receptor_Rfc, Notification_Type): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Receptor_Rfc: Receptor_Rfc,
      Notification_Type: Notification_Type
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Notification_Type_New_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public efosList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Efos_Type_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public efosByRFCList(RFC): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      RFC: RFC
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/CFDI_GET_EFOS_BY_RFC_LIST', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // public uploadFiles(): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key')
  //     XML_File
  //     XML_Name
  //     PDF_File
  //     PDF_File
  //     TransacToken
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Validate', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw(error || 'Internal Server error');
  //     });
  // }

  uploadFiles(transacToken, filePDF, fileXML): Observable<any> {
    const urlContaE = this.globalService.urlContaE();
    const userToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('XML_File', fileXML.files[0]);
    if (filePDF !== undefined && filePDF.files[0] !== undefined) {
      formData.append('PDF_File', filePDF.files[0]);
    }
    // tslint:disable-next-line:max-line-length
    return this.http.post(urlContaE + 'api/Invoice/Invoice_Validate?UserToken=' + userToken + '&TransacToken=' + transacToken, formData);
  }

  // Services Providers

  public getProviderById(Id): Observable<any> {
    const obj = {
      Id_Supplier_Data: Id,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getProviderList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getProviderListAll(idCompany): Observable<any> {
    const obj = {
      Id_Company: idCompany,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/SupplierAllList', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public allSuppliers(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Number(localStorage.getItem('companySelectedLocal'))
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/All_Suppliers', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }




  public Notification_log(obj): Observable<any> {
    // const obj = {
    //   UserToken: localStorage.getItem('key')
    // };
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_log', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }




  public supplierStatusList(Key_Module_Comment): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Key_Module_Comment: Key_Module_Comment
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Status_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cmb_Fiscal_Opinion(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/cmb_Fiscal_Opinion', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierStatus(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierBankList(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Bank_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierStateList(Id_Country): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Country: Id_Country
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Address_Countries_States', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierTaxRegimeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Tax_Regime_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public supplierCountryList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Address_Countries', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierSendInv(Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Token: localStorage.getItem('jwt')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Send_Invitation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierEdit(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_EditData', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierDocSend(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_EditDocument', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Supplier_Fiscal_Opinion(Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Fiscal_Opinion', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierBySupplier(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_UserToken_DATA', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierNew(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    obj.Token = localStorage.getItem("jwt");
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_New', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public updateInterCompany(Id_Supplier_Data, InterCompany): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      InterCompany: InterCompany
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/UpdateInterCompany', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierUpdateEmail(Id_Supplier_Data, Email): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Email: Email
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Update_Email', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
/* Inicio de actualizacion 14/10/2024 */
  public supplierUpdateRfc(Id_Supplier_Data, rfc): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Rfc: rfc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Update_Rfc', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public supplierUpdateCardCode(Id_Supplier_Data, cardcode): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      CardCode: cardcode
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Update_CardCode', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public hideDocument(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Cancel_Document', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
/* Inicio de actualizacion 14/10/2024 */
/* Actualizacion SuperChivas */

  public getSuppliersAutomaticConciliation(idCompany, searchWord, statusC, page, numItems): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: idCompany,
      SearchKey: searchWord,
      AutomaticConciliation_Status: statusC,
      Page: page,
      Pagination: numItems
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/GetSuppliers_AutomaticConciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public automaticConciliation(suppliers): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Suppliers: suppliers
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Automatic_Conciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public automaticConciliationDocument(suppliers): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Suppliers: suppliers
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Automatic_Conciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
/* Actualizacion SuperChivas */
  public supplierUpdateMaxPayments(Id_Supplier_Data, NumMaxPays): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      NumMaxPays: NumMaxPays
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_MaxPays_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierUpdateTolerance(Id_Supplier_Data, Tolerance): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Tolerance: Tolerance
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_Tolerance_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierDelAddress(Id_Supplier_Address): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Address: Id_Supplier_Address,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_DeleteAddress', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierDelAccount(Id_Supplier_Account): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Account: Id_Supplier_Account,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_DeleteAccount', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierDelDocument(Id_Supplier_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Document: Id_Supplier_Document,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_ById_DeleteDocument', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierAvaCompaList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Available_Companies', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierCompaActive(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Company_Active', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierSetCompany(Id_Supplier_Data, Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Set_Company', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierUserToeknEdited(Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_UserToken_Edited', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierCompanyList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Company_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierCatalog(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Catalog', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierCommentTypeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Comment_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierAceptRefusedChange(Id_Supplier_Data, Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_AcceptedRefused_Changes', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public supplierBrokerUpdate(Id_Supplier_Data, Broker): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Broker: Broker
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Broker_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Services Notifications

  public notifCommentList(Id_Inner_Registry, Key_Module): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Key_Module: Key_Module,
      Id_Inner_Registry: Id_Inner_Registry
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Comment_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notifCommentDel(Id_Inner_Registry, Id_Comment, Id_User): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Comment: Id_Comment,
      Id_Inner_Registry: Id_Inner_Registry,
      Id_User_Registry: Id_User
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Comment_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notifCommentNewEdit(Id_Inner_Registry, Text_Comment, Key_Module): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Comment: 0,
      Key_Module: Key_Module,
      Id_Inner_Registry: Id_Inner_Registry,
      Text_Comment: Text_Comment,
      Privacy_Status: false
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Comment_NewEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  // public supplierStatusList(): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key')
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Status_List', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw(error || 'Internal Server error');
  //     });
  // }

  public notifList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notifListPagination(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_List_Pagination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Servicios Notificaciones mandatorias



  public newNotifMandatory(Content, Supplier_Ids, Use_Range, Init_Date, End_Date): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Supplier_Ids: Supplier_Ids,
      Content: Content,
      Use_Range: Use_Range,
      Init_Date: Init_Date,
      End_Date: End_Date,
      Contains_File: false,
      Id_Company: Number(localStorage.getItem('companySelectedLocal'))
    }; const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/NewMandatory', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // uploadFiles
  newNotifMandatoryFile(
    Content,
    Supplier_Ids,
    Use_Range,
    Init_Date,
    End_Date,
    Contains_File,
    fileAdd
  ): Observable<any> {

    const urlContaE = this.globalService.urlContaE();
    const userToken = localStorage.getItem('key');

    const formData = new FormData();

    formData.append('UserToken', userToken || '');
    formData.append('Content', Content || '');
    formData.append('Supplier_Ids', Supplier_Ids || '');
    formData.append('Use_Range', String(Use_Range));
    formData.append('Init_Date', Init_Date || '');
    formData.append('End_Date', End_Date || '');
    formData.append('Contains_File', String(Contains_File));
    formData.append(
      'Id_Company',
      String(Number(localStorage.getItem('companySelectedLocal')))
    );

    if (
      Contains_File &&
      fileAdd !== undefined &&
      fileAdd.files &&
      fileAdd.files[0] !== undefined
    ) {
      formData.append('File', fileAdd.files[0]);
    }

    return this.http.post(
      urlContaE + 'api/Notification/NewMandatoryFile',
      formData
    );
  }





  public pendingNotifMandatory(UserToken): Observable<any> {
    const obj = {
      UserToken: UserToken,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/PendingMandatory', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public acceptNotifMandatory(Id_Mandatory, UserToken): Observable<any> {
    const obj = {
      UserToken: UserToken,
      Id_Comment: Id_Mandatory
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/AceptMandatory ', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public isExistePendingMandatory(UserToken): Observable<any> {
    const obj = {
      UserToken: UserToken,
    }; const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_PendingMandatory ', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public notificationPending(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    }; const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_Pending', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  //CFDI Document

  public cfdiDocumentList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocumentPag(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Pagination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocTypeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Doc_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocStatusList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocConciliation(Id_Document, Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Conciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocDesconciliation(Id_Supplier_ERP_Document_CFDI): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_ERP_Document_CFDI: Id_Supplier_ERP_Document_CFDI
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_DesConciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocDesconciliationAll(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_DesConciliationAll', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocCFDIDelete(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocConciliationList(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_ConciliationGet', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocConciliationFree(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_ConciliationFree', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocListGet(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Get', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public currencyList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Currency', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDILogByRequestToken(TransacToken): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      TransacToken: TransacToken
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Log_By_Request_Token', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDIDocConciSend(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Id_Invoice: 0
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_ConciliationSend', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }



  public CFDIDocNCDiscount(Request_Token, Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Request_Token: Request_Token,
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_NC_Discount', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDIDocNCDelete(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_NC_Discount_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDIDocNCUpdate(Id_Document, Account_Code, Tax_Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Account_Code: Account_Code,
      Tax_Code: Tax_Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_NC_Discount_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // uploads files
  public cfdiDocValidateAddFiles(TransacToken, Id_Company, XML_File, PDF_File, DLV_File, Type_Document): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (XML_File !== undefined && XML_File.files[0] !== undefined) {
      formData.append('XML_File', XML_File.files[0]);
    }
    if (PDF_File !== undefined && PDF_File.files[0] !== undefined) {
      formData.append('PDF_File', PDF_File.files[0]);
    }
    try{
      if (DLV_File !== undefined && DLV_File.files[0] !== undefined) {
      formData.append('DLV_File', DLV_File.files[0]);
      }
    }catch{}

    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Validate?UserToken=' + UserToken + '&TransacToken=' + TransacToken + '&Id_Company=' + Id_Company + '&Type_Document=' + Type_Document, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocAddDelivFile(Id_Invoice, Id_Company, DLV_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (DLV_File !== undefined && DLV_File.files[0] !== undefined) {
      formData.append('DLV_File', DLV_File.files[0]);
    }

    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Delivery_File?UserToken=' + UserToken + '&Id_Invoice=' + Id_Invoice + '&Id_Company=' + Id_Company, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiDocSetPay(Id_Document, Id_Company, PAY_File, Delete): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();
    const Token = localStorage.getItem('jwt');

    if (PAY_File !== undefined) {
      // console.log(PAY_File.files);
      if( PAY_File.files !== undefined) {
        formData.append('PAY_File', PAY_File.files[0]);
      }
    }

    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_SetPay?UserToken=' + UserToken + '&Id_Document=' + Id_Document + '&Id_Company=' + Id_Company + '&Delete=' + Delete + '&Token=' + Token, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  // end uploads files

  // Concepts
  public conceptCreate(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/SpendConcept/SpendConcept_Create', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getConceptList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/SpendConcept/SpendConcept_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public conceptsUpdateAccount(Id_Spend_Concept, Account): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Spend_Concept: Id_Spend_Concept,
      Account: Account
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/SpendConcept/SpendConcept_Account_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public conceptsUpdateStatus(Id_Spend_Concept, Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Spend_Concept: Id_Spend_Concept,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/SpendConcept/SpendConcept_Status_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Servicios comrpobacion Gastos

  public expensesList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesListPag(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_List_Pages', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesByIdConceptsList(Id_CheckingExpenses): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_Detail_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesByIdConceptStatus(Id_CheckingExpenses_Detail, Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses_Detail: Id_CheckingExpenses_Detail,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpensesDetail_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesByIdConceptInvoiceStatus(Id_CheckingExpenses_Detail, Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses_Detail: Id_CheckingExpenses_Detail,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpensesDetailReceiptInvoice_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesStatusList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpensesStatus_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesAddConcepts(Id_CheckingExpenses, Ids_Spend_Concepts): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses,
      Ids_Spend_Concepts: Ids_Spend_Concepts
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpensesDetailBySpendConceptIds_Create', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesConceptsList(Id_Company, Spend_Type): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Spend_Type: Spend_Type
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/SpendConceptByCompany_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesTypeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/ExpenseType_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesReceiptDetail(Id_Receipt): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Receipt: Id_Receipt
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Detail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesReceiptInvoiceDetail(Id_Receipt): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Receipt: Id_Receipt
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Invoice_Detail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesDeleteDocDetail(Id_Receipt): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Receipt: Id_Receipt
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesDelDocInvoiceDetail(Id_Receipt): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Receipt: Id_Receipt
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Invoice_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesUpdateDocDetail(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesUpdateDocInvoiceDetail(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Invoice_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesTotalAmountPediment(Id_CheckingExpenses): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/TotalAmount_Sumary', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesTotalAmountExpense(Id_CheckingExpenses): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Total_ReceiptInvoice_Sumary', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesCurrencyList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Currency_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesSupplierDataList(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/SupplierData_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesHoldingTaxList(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/HoldingTax_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesValidateSend(Id_CheckingExpenses, Expense_Type, Description, Id_Type_Of_Third_Party, Id_Type_Operation): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses,
      Expense_Type: Expense_Type,
      Description: Description,
      Id_Type_Of_Third_Party: Id_Type_Of_Third_Party,
      Id_Type_Operation: Id_Type_Operation
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_ValidateAndSend_Files', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesChangeStatus(Id_CheckingExpenses, Status, Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses,
      Status: Status,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesCreateVerification(Expense_Type, Id_Supplier_Data, Id_Company, Description): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Expense_Type: Expense_Type,
      Id_Supplier_Data: Id_Supplier_Data,
      Id_Company: Id_Company,
      Description: Description
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_Create', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesUploadFileConcept(Id_CheckingExpenses_Detail, Id_Company, PDF_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('Receipt_File', PDF_File.files[0]);

    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/Receipt_Save?UserToken=' + UserToken + '&Id_CheckingExpenses_Detail=' + Id_CheckingExpenses_Detail + '&Id_Company=' + Id_Company, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public expensesUploadFileConceptCFDI(TransacToken, Id_CheckingExpenses_Detail, Id_Company, XML_File, PDF_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('XML_File', XML_File.files[0]);
    formData.append('PDF_File', PDF_File.files[0]);

    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CFDI_Validate?UserToken=' + UserToken + '&Id_CheckingExpenses_Detail=' + Id_CheckingExpenses_Detail + '&Id_Company=' + Id_Company + '&TransacToken=' + TransacToken, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Servicios Estado de cuenta

  public cfdiStatementList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Statement_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public cfdiStatementHeader(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Statement_Header', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Servicios Sincronización a SAP

  public sapTypeList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sapListPag(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces_Pagination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sapList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sapStatusList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sapDateList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces_Date_Range', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public reSendtoSAP(Id_Document, Object_Type): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Object_Type: Object_Type
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Interfaces_Resend', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public partnerGroupList(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_BusinessPartnerGroup', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public asignGroupSupplier(Id_Supplier_Data, Group_Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data,
      Group_Code: Group_Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/SupplierData_Update_GroupCode', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxFreeList(Id_CheckingExpenses): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/HoldingTax_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxSelectedList(Id_CheckingExpenses): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/GetHoldingTaxDetail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxAdd(Id_CheckingExpenses, Id_HoldingTax, Amount): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses,
      Id_HoldingTax: Id_HoldingTax,
      Amount: Amount
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/PostHoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxDelete(Id_CheckingExpenses, Id_HoldingTax): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses,
      Id_HoldingTax: Id_HoldingTax
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/DeleteHoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxFreeListInvoice(Id_Invoice, Id_Company, Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Id_Company: Id_Company,
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/HoldingTax_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxSelectedListInvoice(Id_Invoice, Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/GetHoldingTaxDetail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxAddInvoice(Id_Company, Id_HoldingTax, Id_Document, Amount): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_HoldingTax: Id_HoldingTax,
      Id_Document: Id_Document,
      Amount: Amount
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/PostHoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public holdingTaxDeleteInvoice(Id_Invoice, Id_HoldingTax, Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Id_HoldingTax: Id_HoldingTax,
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/DeleteHoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public invMassiveList(Id_Company, HaveEmail): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      HaveEmail: HaveEmail
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/GetSupplierListMassiveInvitation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public updateLanguage(Language): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Language: Language
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/User/PutLanguage', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public operationsList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/GetTypesOperation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public thirpartyList(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/GetTypesOfThirdParty', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getConciliedStatus(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/GetConciledStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public putConciledStatus(ConciledStatus): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      ConciledStatus: ConciledStatus
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/PutConciledStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  // Nuevos Servicios conciliacion orden de compra Extranjero

  public addDocForeing(Id_Document, PDF_File, DLV_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (PDF_File !== undefined && PDF_File.files[0] !== undefined) {
      formData.append('PDF_File', PDF_File.files[0]);
    }
    if (DLV_File !== undefined && DLV_File.files[0] !== undefined) {
      formData.append('Delivery_File', DLV_File.files[0]);
    }

    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PostInvoiceOfForeigner?UserToken=' + UserToken
      + '&Id_Document=' + Id_Document, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

   public addDocForeingViewPDF(Id_Document, PDF_File, DLV_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (PDF_File !== undefined && PDF_File.files[0] !== undefined) {
      formData.append('PDF_File', PDF_File.files[0]);
    }
    if (DLV_File !== undefined && DLV_File.files[0] !== undefined) {
      formData.append('Delivery_File', DLV_File.files[0]);
    }

    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PostInvoiceOfForeigner_ViewPDF?UserToken=' + UserToken
      + '&Id_Document=' + Id_Document, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public addDocDlvForeing(Id_Invoice, DLV_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (DLV_File !== undefined && DLV_File.files[0] !== undefined) {
      formData.append('Delivery_File', DLV_File.files[0]);
    }

    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PostDelivery?UserToken=' + UserToken
      + '&Id_Invoice=' + Id_Invoice, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public invoiceOfForeignerUpdate(Id_Invoice, Folio): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Folio: Folio,
      Total: 1
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/InvoiceOfForeignerUpdate_ViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getInvoicesOfForeigner(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetInvoicesOfForeigner', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public deleteInvoiceOfForeigner(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/DeleteInvoiceOfForeigner', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sendInvoiceOfForeigner(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/SendInvoiceOfForeigner', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getInvoiceOfForeignerDetail(Id_Invoice) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetInvoiceDetail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public deleteDocumentHistory(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/DeleteDocumentHistory', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public deleteDocumentHistoryNC(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_NC_Discount_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getInvoicesOfForeignerDetail(Id_Invoice) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetInvoicesOfForeignerDetail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getInvoicesOfForeignerDetailViewPDF(Id_Invoice) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetInvoicesOfForeignerDetail_ViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getItemsByCompany(Id_Document) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetItemsByCompany', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public postItems(Id_Invoice, objectPost) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Items: objectPost
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PostItems', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public putDocumentQualification(Id_Document, Status, TaxDate, Division, Id_Invoice_Foreinger, Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Status: Status,
      TaxDate: TaxDate,
      Division: Division,
      Id_Invoice_Foreinger: Id_Invoice_Foreinger,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PutDocumentQualification', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public DeleteItem(Id) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id: Id
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/DeleteItem', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public GetInvoiceItems(Id_Invoice) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetInvoiceItems', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getConciliationSummary(Id_Document) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetConciliationSummary', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getPaymentSupplement(Id_Document) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Brokers/GetPaymentSupplement', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Faltan estos servicios
  public deletePaymentSupplement(Id) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id: Id
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Brokers/DeletePaymentSupplement', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public postPaymentSupplementCFDI(TransacToken, Id_Document, PDF_File, XML_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('XML_File', XML_File.files[0]);
    formData.append('PDF_File', PDF_File.files[0]);

    return this.http.post<any>(this.urlContaE + 'api/Brokers/PostPaymentSupplementCFDI?UserToken=' + UserToken + '&Id_Document=' + Id_Document + '&TransacToken=' + TransacToken, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public deleteConciliationOfPaymentsRelateds(Id_Document) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Brokers/DeleteConciliationOfPaymentsRelateds', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public documentStatusConciled(Id_Document) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Document_StatusConciled', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public checkingExpensesDelete(Id_CheckingExpenses) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_CheckingExpenses: Id_CheckingExpenses
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public document_Save(Id_Document, TaxDate, Division) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      TaxDate: TaxDate,
      Division: Division
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/Document_Save', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Create(Id_Company, Id_Supplier_Data) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Supplier_Data: Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Create', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_List(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_List_Pages(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_List_Pages', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Delete(Id_Pediment) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_SpendConcept_List(Id_Pediment): Observable<any> {
    // console.log(Id_Pediment);
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_SpendConcept_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_SpendConcept_Delete(Id_Pediment_Detail): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment_Detail: Id_Pediment_Detail
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_SpendConcept_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_SpendConceptIds_Create(Id_Pediment, Id_Spend_Concept, Amount): Observable<any> {
    let AmountR = 0;
    if (Amount == '') {
      AmountR = 0;
    } else {
     AmountR = Number(Amount);
    }
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment,
      Id_Spend_Concept: Id_Spend_Concept,
      Amount: AmountR
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_SpendConceptIds_Create', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Sumary_Total(Id_Pediment): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Sumary_Total', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Detail(Id_Pediment): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Detail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Detail_Update(Id_Pediment, Patent_Number, Description, TaxDate) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment,
      Patent_Number: Patent_Number,
      Description: Description,
      TaxDate: TaxDate
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Detail_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pediment_Send(Id_Pediment, Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Pediment: Id_Pediment,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Pediments/Pediment_Send', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  pediment_File_Update(Id_Company, Id_Pediment, Receipt_File): Observable<any> {
    const userToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('Receipt_File', Receipt_File.files[0]);
    // tslint:disable-next-line:max-line-length
    return this.http.post(this.urlContaE + 'api/Pediments/Pediment_File_Update?UserToken=' + userToken + '&Id_Company=' + Id_Company + '&Id_Pediment=' + Id_Pediment, formData);
  }


  public checkingExpenses_Concept_HoldingTax_Update(Id_Receipt_Invoice_Concept_Tax, Id_HoldingTax) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Receipt_Invoice_Concept_Tax: Id_Receipt_Invoice_Concept_Tax,
      Id_HoldingTax: Id_HoldingTax
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CheckingExpenses/CheckingExpenses_Concept_HoldingTax_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public document_Detail_HoldingTax(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Document_Detail_HoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public document_Detail_HoldingTax_Update(TaxType, Id_Document_Line, Id_HoldingTax_ISR, Id_HoldingTax_IVA): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      TaxType: TaxType,
      Id_Document_Line: Id_Document_Line,
      Id_HoldingTax_ISR: Id_HoldingTax_ISR,
      Id_HoldingTax_IVA: Id_HoldingTax_IVA
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Document_Detail_HoldingTax_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  /////////////////////////////////////////////////////////////////////

  public CFDI_Document_Cat_Dimensions(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Cat_Dimensions', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Document_Center_Cost_By_Dimension(Id_Company, Dimension_Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Dimension_Code: Dimension_Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Center_Cost_By_Dimension', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Document_Projects(Id_Company, SearchKey): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      SearchKey: SearchKey
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Projects', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Document_Series(Id_Company, SAP_Object_Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      SAP_Object_Code: SAP_Object_Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Series', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Document_Detail_By_Id(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Detail_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // cfdiDocumentList()

  public CFDI_Document_Center_Cost_Dimensions(Id_Company, SearchKey): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      SearchKey: SearchKey
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Center_Cost_Dimensions', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  // OKGs Parametros abent 412
  public CFDIDocConciAuth(Id_Document, Authorize, Num_At_Card, Id_Series, Id_Project,
                          Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5, DocDate_Create
                          , Object_Type
                          ,DocTaxDate_Create, DocTaxRate_Create, selectedRetentionIVA
                          ) : Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Authorize: Authorize,
      Num_At_Card: Num_At_Card,
      Id_Series: Id_Series,
      Id_Project: Id_Project,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5,
      DocDate_Create: DocDate_Create,
      Object_Type: Object_Type,
      DocTaxDate_Create: DocTaxDate_Create,
      DocTaxRate_Create: DocTaxRate_Create,
      WithholdingTaxes: Object.values(selectedRetentionIVA)
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Conciliation_Authorization', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public CFDI_Document_Has_Withheld_Taxes(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Document_Has_Withheld_Taxes', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public Get_Parameters_List(Id_Company, Id_Parameter, Group_Param, Description, Type_Param=1 ): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Parameter: Id_Parameter,
      Group_Param: Group_Param,
      Description: Description,
      Type_Param: Type_Param
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  ///////////////////////////////////////////////////

  // Servicios Parametros

  public Get_Parameters_List_Client(idCompany, Group_Param:string = ''): Observable<any> {
    const obj = {
      Id_Company: idCompany,
      UserToken: localStorage.getItem('key'),
      Group_Param:Group_Param,
      Type_Param:2
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List_Client', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public get_Parameters_List(idCompany): Observable<any> {
    const obj = {
      Id_Company: idCompany,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public get_Parameters_List_Update(idCompany): Observable<any> {
    const obj = {
      Id_Company: idCompany,
      UserToken: localStorage.getItem('key'),
      Group_Param: "GEN",
      Type_Param: ""
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public get_Parameters_List_Autorization(idCompany): Observable<any> {
    const obj = {
      Id_Company: idCompany,
      UserToken: localStorage.getItem('key'),
      Group_Param: "",
      Type_Param: ""
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List_Client', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public update_Parameter_By_Id(idCompany, Id_Parameter, Value): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: idCompany,
      Id_Parameter: Id_Parameter,
      Value: Value
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Update_Parameter_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Lst(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/CFDI_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Invoice_Range_List(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Invoice_Range_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Invoice_Combo_Document_Type(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Invoice_Combo_Document_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public CFDI_Get(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Get', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_ConciliationSend(Id_Invoice, DocDate_Create): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      DocDate_Create: DocDate_Create
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_ConciliationSend', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Documents_Available_Lst(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Documents_Available_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Documents_Assigned_CFDI(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Documents_Assigned_CFDI', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public Documents_Assigned_CFDI_Header(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Documents_Assigned_CFDI_Header', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Payments_Pending_Validate(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Payments_Pending_Validate', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_Conciliation(Id_Invoice, Id_Document, Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Id_Document: Id_Document,
      Id_Company: Id_Company,
    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Conciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public CFDI_DesConciliation(Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_DesConciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }



  public UloadCoupleFiles(TransacToken, Id_Company, fiXML, fiPDF): Observable<any> {
    const formData = new FormData();
    const UserToken = localStorage.getItem('key');
    if (fiXML != null && fiXML != undefined) { formData.append('XML_File', fiXML.file.rawFile); }
    if (fiPDF != null && fiPDF != undefined) { formData.append('PDF_File', fiPDF.file.rawFile); }

    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_Validate_Any?UserToken=' + UserToken + '&TransacToken=' + TransacToken + '&Id_Company=' + Id_Company, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });

  }

  // public uploadAnyFiles(TransacToken, Id_Company, XML_File, PDF_File) {

  //   if (XML_File != undefined && XML_File.length > 0) {

  //     XML_File.forEach(function (f) {
  //       let fiXML = f.sXML;
  //       let fiPDF = f.sPDF;
  //       this.UloadCoupleFiles(TransacToken, Id_Company, fiXML, fiPDF).subscribe(resp => {
  //         if (this.globalService.verifyResponse(resp)) {
  //           this.logDocLst.push(resp);
  //           // console.log(this.logDocLst);
  //         }
  //       });

  //     });
  //   }

  //   if (PDF_File !== undefined && PDF_File.length > 0) {
  //     PDF_File.forEach(function (f) {
  //       let fiPDF = f;
  //       console.log(fiPDF);

  //       this.UloadCoupleFiles(TransacToken, Id_Company, null, fiPDF).subscribe(resp => {
  //         if (this.globalService.verifyResponse(resp)) {
  //           this.logDocLst.push(resp);
  //           // console.log(this.logDocLst);
  //         }
  //       });

  //     });

  //   }

  //   return;
  // }



  public Get_URL_Efos_Report(RFC): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      RFC: RFC

    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/Get_URL_Efos_Report', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Documents_Autorization_CFDI(obj, DocDate_Create): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    obj.DocDate_Create = DocDate_Create;
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Documents_Autorization_CFDI', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Document_Line_Update_Quantity(Id_Document_Line, Quantity): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document_Line: Id_Document_Line,
      Quantity: Quantity
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Document_Line_Update_Quantity', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public Document_Line_Update_Price(Id_Document_Line: number, Price ): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document_Line: Id_Document_Line,
      Price: Price
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/Document_Line_Update_Price', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Notification_Mandatory_List_By_User(Page): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Page: Page,
      Pagination: 5
      //  UserToken: "037f0578-8884-4ad1-bb10-9783f91ff528"
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Notification/Notification_Mandatory_List_By_User', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public SMTPById(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'SMTP/SMTP_By_Id', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public SMTPNewEdit(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key'); //token
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'SMTP/SMTP_NewEdit', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public SMTPReset(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'SMTP/SMTP_Reset', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public SMTP_Reset_Config(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'SMTP/SMTP_Reset_Config', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }






  public Get_Status_CFDI_Supplier(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/CFDIDocument/Get_Status_CFDI_Supplier', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Get_Currency_Per_Supplier(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/CFDIDocument/Get_Currency_Per_Supplier', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Get_Month_Supplier(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/CFDIDocument/Get_Month_Supplier', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Get_Year_Per_Supplier(Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/CFDIDocument/Get_Year_Per_Supplier', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Delete_AnyDocument(Id_Invoice, Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice,
      Id_Document: Id_Document
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/CFDIDocument/Delete_Any', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }
//GS Funciona para validar la vigencia de documentos 04/06/2021
  public Supplier_Validity_Documents(UserToken): Observable<any> {
    const obj = {
      UserToken: UserToken,
    }; const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_Validity_Documents ', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  //Cambios IMPERQUIMIA
  //Añadir servicio para validar si tiene logo parametrizado a Nivel organización
  public Get_Path_Logo_Navigation(): Observable<any> {
    const obj = {
      UserToken: this.token,
    }; const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Navigation/Get_Path_Logo_Navigation ', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Allow_Card_Supplier_New(): Observable<any> {

    const obj = {
      UserToken: localStorage.getItem('key')
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Supplier/Allow_Card_Supplier_New', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  //Three way match
  public threeWayDataList(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/ThreeWayMatch/GetData', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public threeWayAllSuppliers(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/ThreeWayMatch/All_Suppliers', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public threeWayDetail(docNum): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Doc_Num: docNum
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/ThreeWayMatch/GetDocumentDetail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  // Se agregan servicios para Interfaces

  public GetHoldingTax(Id_Company, Id_holding): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_HoldingTax: Id_holding
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/GetHoldingTax', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public AddHoldingTax({Id_Company, code, desc, status}): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Code: code,
      Description: desc,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/AddHoldingTax', json, { headers: this.headers })
    .catch(error => {
      return Observable.throw(error || 'Internal Server error');
    });
  }
  public UpdateCode(Id_Company, Id_holding, Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_HoldingTax: Id_holding,
      Code: Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateCode', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateDescription(Id_Company, Id_holding, desc): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_HoldingTax: Id_holding,
      Description: desc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateDescription', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateStatus(Id_Company, Id_holding, status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_HoldingTax: Id_holding,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public GetItems(Id_Company, Id_Item): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Item: Id_Item
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/GetItems', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public AddItem({Id_Company, code, desc, status}): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Code: code,
      Description: desc,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/AddItem', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateItemCode(Id_Company, Id_Item, Code): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Item: Id_Item,
      Code: Code
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateItemCode', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateItemDescription(Id_Company, Id_Item, desc): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Item: Id_Item,
      Description: desc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateItemDescription', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateItemStatus(Id_Company, Id_Item, status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Item: Id_Item,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateItemStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public GetForeignInvoicesStats( month, year): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Months: month,
      Year: year
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetForeignInvoicesStats', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public GetForeignInvoices( month, year, estatus, page, pagination): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Months: month,
      Year: year,
      Status: estatus,
      Page: page,
      Pagination: pagination
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetForeignInvoices', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public DeleteForeignInvoice(Id): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice_Foreinger: Id
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/DeleteForeignInvoice', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Gs
  //Vista PDF
  //Funcion para relacionar documentos:
  public AddRelatedDocument( id_company, id_document_foreigner, id_invoice_foreinger): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company:id_company,
      Id_Document_Foreigner:id_document_foreigner,
      Id_Invoice_Foreinger: id_invoice_foreinger
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/RelatedDocumentRequest', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

    //Funcion para desconciliar documentos:
    public RemoveRelatedDocument( id_document_foreigner, id_invoice_foreinger): Observable<any> {
      const obj = {
        UserToken: localStorage.getItem('key'),
        Id_Document_Foreigner:id_document_foreigner,
        Id_Invoice_Foreinger: id_invoice_foreinger
      };
      const json = JSON.stringify(obj);
      return this.http.post<any>(this.urlContaE + 'api/Foreigner/RemoveRelatedDocument', json, { headers: this.headers })
        .catch(error => {
          return Observable.throw(error || 'Internal Server error');
        });
    }

  public putDocumentQualificationViewPDF(Id_Document, Status, TaxDate, Division, Id_Invoice_Foreinger, Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5, Id_Series) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document: Id_Document,
      Status: Status,
      TaxDate: TaxDate,
      Division: Division,
      Id_Invoice_Foreinger: Id_Invoice_Foreinger,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5,
      Id_Series : Id_Series
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PutDocumentQualificationViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getDocumentsAvailableViewPDF(obj) {
    obj.UserToken = localStorage.getItem('key');
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Documents_Available_ViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public getDocumentsAssignedViewPDF(Id_Invoice) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDI/Documents_Assigned_ViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pdf_Conciliation(Id_Invoice, Id_Document, Id_Company): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice_Foreinger: Id_Invoice,
      Id_Document_Foreigner: Id_Document,
      Id_Company: Id_Company,
    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/AddRelatedDocument', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public pdf_DesConciliation(Id_Document, Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Document_Foreigner: Id_Document,
      Id_Invoice_Foreinger: Id_Invoice
    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/RemoveRelatedDocument', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public sendInvoiceOfForeignerViewPdf(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
      const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/SendInvoiceOfForeigner_ViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

   public putDocumentQualificationViewPdf(Id_Document, Status, TaxDate, Division, Id_Invoice_Foreinger, Id_CostCenter_1, Id_CostCenter_2, Id_CostCenter_3, Id_CostCenter_4, Id_CostCenter_5) {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Series: Id_Document,
      Status: Status,
      TaxDate: TaxDate,
      Division: Division,
      Id_Invoice_Foreinger: Id_Invoice_Foreinger,
      Id_CostCenter_1: Id_CostCenter_1,
      Id_CostCenter_2: Id_CostCenter_2,
      Id_CostCenter_3: Id_CostCenter_3,
      Id_CostCenter_4: Id_CostCenter_4,
      Id_CostCenter_5: Id_CostCenter_5
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/PutDocumentQualificationViewPDF', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public GetAdditionalInfoByIdForeign(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice_Foreinger: Id_Invoice
    };    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Foreigner/GetAdditionalInfoByIdForeign', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public GetTaxesItems(Id_Company, Id_Item): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Item: Id_Item
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/GetTaxDetermination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public AddTaxes({Id_Company, code, desc, rate, status}): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Code: code,
      Description: desc,
      Rate: rate,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/AddTaxDetermination', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateTaxStatus(Id_Company, Id_Tax, status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Tax_Determination: Id_Tax,
      Active: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateTaxDeterminationStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public UpdateTaxRate(Id_Company, Id_Tax, rate): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Tax_Determination: Id_Tax,
      Rate: rate
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Catalog/UpdateTaxDeterminationRate', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public GetList(Id_Company, status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IdCustomer: Id_Company,
      Status: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/PaymentTerms/GetList', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public AddOrUpdate({Id_Company, key, desc}): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IdCustomer: Id_Company,
      Key: key,
      Description: desc,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/PaymentTerms/AddOrUpdate', json, { headers: this.headers })
    .catch(error => {
      return Observable.throw(error || 'Internal Server error');
    });
  }
  public ChangeStatus(Id_Company, key, status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      IdCustomer: Id_Company,
      Key: key,
      Status: status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/PaymentTerms/ChangeStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public GetListLogs(DateFrom, DateTo, Page, Pagination, LogLevel, SearchKey): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      DateFrom: DateFrom,
      DateTo: DateTo,
      Page: Page,
      Pagination: Pagination,
      LogLevel: LogLevel,
      SearchKey: SearchKey
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/LogActivity/QueryEntries', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public CFDI_WithholdingTaxes(Id_Company, Id_Document): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Id_Document: Id_Document
    };
    console.log("CFDI_WithholdingTaxes >>" + JSON.stringify(obj));
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/CFDI_WithholdingTaxes', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  public GetCFDITaxes(Id_Invoice): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Invoice: Id_Invoice
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/CFDIDocument/GetCFDITaxes', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
  // ================================
// UDF
// ================================

  public getUdfList(Id_Company): Observable<any> {

    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Number(Id_Company)
    };

    const json = JSON.stringify(obj);

    return this.http.post<any>(
      this.urlContaE + 'api/Udf/Get',
      json,
      { headers: this.headers }
    )
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }


  public saveUdfFields(Id_Company, Data): Observable<any> {

    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Number(Id_Company),
      Data: Data
    };

    const json = JSON.stringify(obj);

    return this.http.post<any>(
      this.urlContaE + 'api/Udf/Save',
      json,
      { headers: this.headers }
    )
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/rest/all.service.ts